export default {
  common: {
    welcome: '欢迎',
    login: '登录',
    register: '注册',
    logout: '退出登录',
    email: '邮箱地址',
    password: '密码',
    confirmPassword: '确认密码',
    username: '用户名',
    nickname: '昵称',
    rememberMe: '记住我',
    forgotPassword: '忘记密码？',
    submit: '提交',
    cancel: '取消',
    loading: '加载中...',
    success: '成功',
    error: '错误',
    required: '必填',
    optional: '可选',
    back: '返回',
    next: '下一步',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    create: '创建',
    search: '搜索',
    filter: '筛选',
    reset: '重置',
    actions: '操作',
    copyright: '© 2025 SpatialWalk. All Rights Reserved.',
    openPlatform: '开放平台',
    adminPlatform: '管理平台',
    welcomeToOpenPlatform: '欢迎使用 SpatialWalk 开放平台管理平台',
    redirecting: '正在跳转...',
    console: '控制台',
    getStarted: '开始使用',
    learnMore: '了解更多',
  },
}
